module.exports = __webpack_public_path__ + "img/biao4.2f7d1ef6.webp";